import React, { useState, Fragment, useEffect } from "react";
import LaddaButton, { ZOOM_OUT, XS } from "react-ladda";
import ModalCurrency from "../../Modals/ModalCurrency";
import { Table, Button } from "reactstrap";
import { LoadingMessage } from "../../Controls";
import { useEntities } from "../../Wizzard";
import { Mode, WizzMode } from "../../types";

const Currency = ({
  mode,
  assetId,
  settleCurrencies,
  currencies,
  services,
  wizzToggle,
  wizzOnChange,
}) => {
  const [readonly, setReadonly] = useState(mode == WizzMode.View);
  const [modalCurrency, setModalCurrency] = useState({ open: false });
  const [deleting, setDeleting] = useEntities({});

  useEffect(() => {
    if (mode) {
      setReadonly(mode == WizzMode.View);
    }
  }, [mode]);

  const toggle = (props) => {
    setModalCurrency({ open: !modalCurrency.open, ...props });
  };

  // handle grid actions
  const handleAction = (action, currencyId) => {
    if (action == Mode.Insert) {
      toggle({
        assetId,
        action,
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Update) {
      toggle({
        assetId,
        action,
        currency: settleCurrencies.find(
          (c) => c.SettlementCurrencyId == currencyId
        ),
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Delete) {
      wizzToggle("confirm", {
        title: "Delete settlement currency",
        message: "Are you sure you want to delete settlement currency?",
        onConfirm: () => handleDelete(currencyId),
      });
    }
  };

  // callback after modal confirm
  const handleSave = (action, currency) => {
    return services
      .updateSettleCurrency({
        assetId,
        action,
        currency,
      })
      .then((res) => res.result)
      .then((result) => {
        if (result.Code == 200) {
          wizzOnChange({
            SettlementCurrencies: [currency].concat(
              settleCurrencies
                .filter(
                  (e) => e.SettlementCurrencyId != currency.SettlementCurrencyId
                )
                .map((e) => ({
                  ...e,
                  SettlementCurrencyIsDefault:
                    !currency.SettlementCurrencyIsDefault &&
                    e.SettlementCurrencyIsDefault,
                }))
            ),
          });
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }

        return result.Code;
      });
  };

  // callback after confirm delete
  const handleDelete = (id) => {
    setDeleting({ [id]: true });
    services
      .updateSettleCurrency({
        assetId,
        action: Mode.Delete,
        currency: settleCurrencies.find((e) => e.SettlementCurrencyId == id),
      })
      .then((res) => res.result)
      .then((result) => {
        setDeleting({ [id]: false });
        if (result.Code == 200) {
          settleCurrencies.splice(
            settleCurrencies.findIndex((e) => e.SettlementCurrencyId == id),
            1
          );
          wizzOnChange({
            SettlementCurrencies: settleCurrencies,
          });
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }
      });
  };

  return (
    <div>
      {!readonly && (
        <Button
          color="primary"
          className="mb-3"
          onClick={() => handleAction(Mode.Insert)}
        >
          <i className="fa fa-plus mr-1" aria-hidden="true"></i>
          Add Settlement currency
        </Button>
      )}
      <Table>
        <thead>
          <tr>
            <th>ISO</th>
            <th>Description</th>
            <th>Is Default</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {settleCurrencies ? (
            <Fragment>
              {settleCurrencies.map((item) => (
                <tr key={`set-${item.SettlementCurrencyId}`}>
                  <td>{item.SettlementCurrencyISO}</td>
                  <td>{item.SettlementCurrencyDescription}</td>
                  <td>{item.SettlementCurrencyIsDefault ? "Yes" : "No"}</td>
                  <td>
                    {!readonly && (
                      <Actions
                        id={item.SettlementCurrencyId}
                        action={handleAction}
                        deleting={!!deleting[item.SettlementCurrencyId]}
                      />
                    )}
                  </td>
                </tr>
              ))}
              {settleCurrencies.length == 0 && <EmptyOrLoading />}
            </Fragment>
          ) : (
            <EmptyOrLoading loading={true} />
          )}
        </tbody>
      </Table>

      {modalCurrency.open && (
        <ModalCurrency
          {...modalCurrency}
          toggle={toggle}
          currencies={currencies}
        />
      )}
    </div>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="3">
      {loading ? (
        <LoadingMessage text="Loading currencies" />
      ) : (
        <span className="text-center d-block h5 m-3" style={{textAlign: "center"}}>No currencies</span>
      )}
    </td>
  </tr>
);

const Actions = ({ action, id, deleting }) => (
  <div className="d-flex justify-content-end">
    <Button
      color="primary"
      size="sm"
      className="mr-2"
      onClick={() => action(Mode.Update, id)}
    >
      <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
    </Button>

    <LaddaButton
      className="btn btn-ladda btn-danger btn-sm"
      loading={deleting}
      onClick={() => action(Mode.Delete, id)}
      data-style={ZOOM_OUT}
      data-size={XS}
    >
      <i className="fa fa-trash-o" aria-hidden="true"></i>
    </LaddaButton>
  </div>
);

export default Currency;
